export const icons = [
  { name: "Initial Access" },
  { name: "Execution" },
  { name: "Persistence" },
  { name: "Privilege Escalation" },
  { name: "Defense Evasion" },
  { name: "Credential Access" },
  { name: "Discovery" },
  { name: "Lateral Movement" },
  { name: "Collection" },
  { name: "Command and Control" },
  { name: "Exfiltration" },
  { name: "Impact" }
];
